<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <div v-if="orders.length > 0">
          <div class="d-flex justify-start pb-2 pt-2">
            <v-btn
              class=""
              @click="selectAll"
              color="secondary">{{ $t('calls.select_all') }}
            </v-btn>
          </div>
          <v-row>
            <v-col
              v-for="order in orders"
              :key="order.uuid"
              cols="12" lg="3"
              md="4" sm="6"
              class="py-1"
            >
              <v-card
                class="pa-1"
                :style="{
                  background: (!!(order.is_subscription)?'#0000001a':'white')
                  }"
              >
                <contact-line :contact="order.contact"/>
                <v-divider/>
                <cleaners-line :cleaners="order.cleaners"/>
                <v-divider/>
                <datetime-alert
                  v-if="order.datetime"
                  :datetime="moment(order.datetime)"
                />
                <is-hoover
                  style="vertical-align: sub"
                  fill="red"
                  v-if="hooverModeEnable() && order.contact.address_is_hoover"
                />
                <div v-if="order.zvonok && order.zvonok.cleaners"
                     style="font-size: 12px"
                     class="red white--text pa-2 text-center font-weight-bold">
                  {{ $t('calls.sent_to_call') }}: {{
                    moment.utc(order.zvonok.cleaners)
                      .local()
                      .format(DATETIME_VIEW)
                  }}
                  <div v-if="order.zvonok.results && order.zvonok.results.cleaners">
                    {{ $t('calls.result') }}: {{ order.zvonok.results.cleaners }}
                  </div>
                </div>
                <v-divider/>
                <v-flex class="d-flex justify-space-between">
                  <div>
                  <span
                    class="pointer"
                    @click.prevent="copyUuid(order.uuid)"
                  >
                  <v-icon>mdi-content-copy</v-icon>
                </span>
                    <router-link :to="{ name: 'orders.base.show', params: { orderUuid: order.uuid }}"
                                 target='_blank'>
                      <v-icon>mdi-link-box-variant-outline</v-icon>
                    </router-link>
                  </div>
                  <div>
                    <input
                      :disabled="(order.zvonok && order.zvonok.cleaners) || (!order.cleaners || order.cleaners.length <= 0)"
                      style="width: 20px; height: 20px;"
                      type="checkbox" :value="order.uuid" v-model="selectedOrders">
                  </div>
                </v-flex>
              </v-card>
            </v-col>
          </v-row>

          <div class="d-flex justify-center align-center pt-2">
            <v-btn
              class="mx-auto"
              :disabled="selectedOrders.length <= 0"
              @click="isShowConfirmation=true"
              color="primary">{{ $t('calls.sent_to_call') }}
            </v-btn>
          </div>
        </div>
        <div v-else>
          <div class="text-center font-weight-bold py-5 px-2">
            {{ $t('calls.empty') }}
          </div>
        </div>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
      <!-- End: Edit Modal -->
      <accept-dialog
        :is-open-dialog="isShowConfirmation"
        @on-close="isShowConfirmation=false"
        @on-accept="onAcceptConfirmation"
      >
        <div class="pt-6">
          {{ $t('calls.sent_to_call') }}? <br>
          {{ $t('calls.selected_records') }}: {{ selectedOrders.length }}
        </div>
      </accept-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
/* utils */
/* constants */
import { DATETIME_VIEW } from '@/constants/dates';
/* proxy */
import ApprovementListProxy from '@/proxies/ZvonokCom/ApprovementListProxy';
/* mixins */
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import settingsMixin from '@/mixins/settingsMixin';
/* components */
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import AcceptDialog from '@/components/AcceptDialog.vue';
import ContactLine from '@/components/minialerts/ContactLine.vue';
import CleanersLine from '@/components/minialerts/CleanersLine.vue';
import DatetimeAlert from '@/components/minialerts/DatetimeAlert.vue';
import IsHoover from '@/components/minialerts/IsHoover.vue';
import i18n from '@/i18n';

export default {
  name: 'OrdersBase',
  mixins: [
    updatePageContentMixin,
    settingsMixin,
  ],
  components: {
    ModalLoading,
    AcceptDialog,
    ContactLine,
    CleanersLine,
    DatetimeAlert,
    IsHoover,
  },
  data() {
    return {
      moment,
      DATETIME_VIEW,
      firstLoad: true,
      pageLoading: false,
      /* Listing management */
      isShowConfirmation: false,
      isTableLoading: false,
      orders: [],
      selectedOrders: [],
    };
  },
  created() {
    this.isTableLoading = true;
    this.fetchData();
  },
  computed: {},
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new ApprovementListProxy()
        .ordersBaseCleaners()
        .then((response) => {
          this.orders = response.data.data.orders;
          if (this.firstLoad) {
            this.firstLoad = false;
            this.selectAll();
          }
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.orders = [];
          this.selectedOrders = [];
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    onAcceptConfirmation() {
      this.isRequestingNow = true;
      new ApprovementListProxy()
        .sendOrdersBaseCleaners({
          uuids: this.selectedOrders,
        })
        .then((response) => {
          this.selectedOrders = [];
          setTimeout(() => {
            this.fetchData();
          }, 0);
        })
        .catch((error) => {
          console.warn(error);
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    copyUuid(text) {
      this.$clipboard(text)
        .then(() => {
          this.$store.dispatch('page/displaySnackbar', { text: `${i18n.t('calls.uuid_copy')}:${text}` });
        }, (e) => {
          console.log(e);
          // eslint-disable-next-line no-alert
          alert(i18n.t('calls.error_copy'));
        });
    },
    selectAll() {
      this.orders.forEach((order) => {
        if ((order.zvonok && order.zvonok.cleaners) || (!order.cleaners || order.cleaners.length <= 0)) {

        } else {
          this.selectedOrders.push(order.uuid);
        }
      });
    },
  },
};
</script>

<style>
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers td:nth-child(2) {
  width: 100%;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}

#customers .bolder-row {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #af5149;
  color: white;
}
</style>
